import React from 'react';
import {bindActionCreators} from "redux";
import {addSlide} from "../../actions/addSlide";
import {updateSlide} from "../../actions/updateSlide";
import connect from "react-redux/es/connect/connect";

function Gallery({id, addSlide, slides, updateSlide}) {

    return (
        <div className="form-group" key={id}>
            <label>Galeria</label>
            <button type="button" className="btn btn-info ml-4 px-3" onClick={() => addSlide(id)}>+</button>
            {Object.keys(slides).map((key) => (
                <input key={key} type="url" className="form-control"
                       value={slides[key]}
                       onChange={(event) => updateSlide(event.target.value, key, id)}/>
            ))}
        </div>
    );
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({addSlide, updateSlide}, dispatch);
}

export default connect(null, mapDispatchToProps)(Gallery);


// WEBPACK FOOTER //
// ./src/admin/components/editor/containers/sections/Gallery.js